import React from 'react';
import PropTypes from "prop-types";

import {Button} from 'reactstrap';

import Framework from "@beardeddevops/react.framework";
import {Objects} from "components";
import FFLTextField from "components/Elements/FFLTextField";
import UniversalModalOverride from "components/UniversalModalOverride";


export default class TransactionImporter extends React.Component {
	static propTypes = {
		object: PropTypes.object.isRequired,
		properties: PropTypes.object.isRequired,
		locations: PropTypes.array.isRequired,
		history: PropTypes.object.isRequired,
		shouldLoad: PropTypes.bool.isRequired,
		afterImporterSave: PropTypes.func.isRequired,
		onTextUpdate: PropTypes.func.isRequired,
		onSelectUpdate: PropTypes.func.isRequired,
	};

	constructor(props, context) {
		super(props, context);
		this.state = {
			id: null,
			binary_id: null,
			object: null,
			ImporterModalOpen: false,
		};
	}

	handleToggleImporterModal = () => {
		this.setState({importerModalOpen: !this.state.importerModalOpen});
	}

	handleAddImporterClick = () => {
		this.setState({
			id: null,
			binary_id: null,
			object: null
		});

		this.handleToggleImporterModal();
	}

	handleEditImporterClick = () => {
		/** @type {Transactions_Collections_Object} object */
		let object = this.props.object;

		this.setState({
			id: object.importer,
			binary_id: object.binary_id,
			object: object.importers,
		});

		this.handleToggleImporterModal();
	}

	render() {
		/** @type {Transactions_Collections_Object} object */
		let object = this.props.object;
		let {properties, shouldLoad, onSelectUpdate, onTextUpdate, afterImporterSave} = this.props;
		let {importerModalOpen} = this.state;
		return (
			<div>
				<div className={'form-group'}>
					<div className="row">
						<div className="col-3">
							<span className="input-label">Importer</span>
							<UniversalModalOverride
								locations={this.props.locations}
								states={this.props.states}
								history={this.props.history}
								id={this.state.id}
								binary_id={this.state.binary_id}
								name={"Importer"}
								object={Objects.Importer}
								objectProps={{
									object: this.state.object
								}}
								showModal={importerModalOpen}
								handleToggle={this.handleToggleImporterModal}
								afterSave={afterImporterSave}
							/>
						</div>
						<div className="col-9 d-flex">
							<Button
								data-id={'add-importer'}
								onClick={this.handleAddImporterClick}
								className={"select-add"}
								size={"sm"} outline color="primary"
							>
								<i className={"fa fa-plus"}/>
							</Button>
							{object.importer ?
								<Button
									data-id="edit-importer"
									onClick={this.handleEditImporterClick}
									className="select-add"
									size="sm"
									outline color="green-meadow"
								>
									<i className="fa fa-pencil"/>
								</Button>
								: null}
							<div className={'flex-grow-1'}>
								<Framework.Elements.Select
									shouldLoad={shouldLoad}
									property={properties.importer}
									value={object.importer}
									binary_id={object.importer_binary_id}
									error={object.importer_error}
									object={object.importers}
									update={onSelectUpdate}
									text={'name|name_display'} //
									textHelper={'ffl'} //
									nullable={true}
									sort={'name'}
								/>
							</div>
						</div>
					</div>
				</div>
				<p style={{
					color: "gray",
					padding: "0 4px",
					marginBottom: "19px",
					fontSize: "11px",
					lineHeight: '12px'
				}}>
					The importer name and FFL are stored with the transaction to
					preserve past Bound Book records in the event the importer's name
					or FFL number changes.
				</p>
				<div className="form-group">
					<Framework.Elements.TextField
						label={"Importer Name"}
						property={properties.importer_name_display}
						value={object.importer_name_display}
						error={object.importer_name_display_error}
						update={onTextUpdate}
						disabled={typeof this.props.disableFields !== 'undefined' ? this.props.disableFields : false}
					/>
				</div>
				<div className="form-group">
					<Framework.Elements.TextField
						label={"Importer FFL"}
						property={properties.importer_ffl}
						value={object.importer_ffl}
						error={object.importer_ffl_error}
						update={onTextUpdate}
						disabled={typeof this.props.disableFields !== 'undefined' ? this.props.disableFields : false}
					/>
				</div>
				<div className="form-group">
					<Framework.Elements.TextField
						label={"Importer Address"}
						property={properties.importer_full_address}
						value={object.importer_full_address}
						error={object.importer_full_address_error}
						update={onTextUpdate}
						disabled={typeof this.props.disableFields !== 'undefined' ? this.props.disableFields : false}
					/>
				</div>
			</div>
		);
	}
}

